import { defineComponent as _defineComponent } from 'vue'
import {
  PropType, computed, inject, watch,
} from 'vue';
import {
  bankTransferInstructionsInfo,
  invoiceInfo as getInvoiceInfo, intentInfo as getIntentInfo, subscriptionInfo as getSubscriptionInfo,
} from '@/services/billing-utils';
import i18nn from '@/plugins/i18n';
import {
  Invoice, SetupIntent, Subscription, SubscriptionStatus,
} from '@/api/api-billing';
import { PaymentWizardStep, PaymentWizardStepKey } from '@/services/payment-wizard-utils';
import store from '@/store/store';
import PaymentSuccessIntent from './PaymentSuccessIntent.vue';
import PaymentSuccessInvoice from './PaymentSuccessInvoice.vue';
import PaymentSuccessSubscription from './PaymentSuccessSubscription.vue';
import PaymentSuccessBankTransferInstructions from './PaymentSuccessBankTransferInstructions.vue';
import PaymentSuccessMandateInstructions from './PaymentSuccessMandateInstructions.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentSuccess',
  props: {
  invoice: { type: Object as PropType<Invoice|undefined>, required: false, default: undefined },
  setupIntent: { type: Object as PropType<SetupIntent|undefined>, required: false, default: undefined },
},
  setup(__props) {

const props = __props;




const intentInfo = computed(() => {
  const showSetup = !props.invoice?.paymentIntent?.lastError && !!props.setupIntent?.lastError;
  const intent = showSetup ? props.setupIntent : props.invoice?.paymentIntent ?? props.setupIntent;
  if (!intent) return undefined;
  return getIntentInfo(intent);
});

const isIntentError = computed(() => intentInfo.value?.error !== undefined);

const bankTransferInfo = computed(() => {
  if (!props.invoice?.paymentIntent?.nextAction?.displayIBANBankTransferInstructions) return undefined;
  return bankTransferInstructionsInfo(props.invoice.paymentIntent.nextAction.displayIBANBankTransferInstructions);
});

const invoiceInfo = computed(() => {
  if (!props.invoice) return undefined;
  return getInvoiceInfo(props.invoice);
});

const subscription = computed(() => store.getters.billingSubscription ?? undefined as Subscription | undefined);

const subscriptionInfo = computed(() => {
  if (!subscription.value || !props.invoice || subscription.value?.invoice?.ID !== !props.invoice.ID) return undefined;
  if (subscription.value.status !== SubscriptionStatus.Active) return undefined;

  return getSubscriptionInfo(subscription.value);
});

const mandateInfo = computed(() => {
  if (props.setupIntent?.mandate?.type !== 'sepa_debit') return undefined;

  const { reference, url } = props.setupIntent?.mandate ?? {};
  if (!url) return undefined;
  return { reference, url };
});

const visibleInfos = computed(() => {
  if (isIntentError.value) return { intent: true }; // payment or setup intent error
  if (bankTransferInfo.value) return { bankTransfer: true }; // bank transfer expected
  if (mandateInfo.value) return { mandate: true }; // sepa debit info from setup intent
  if (subscriptionInfo.value) return { subscription: true }; // last invoice of subscription
  if (invoiceInfo.value) return { invoice: true }; // invoice
  if (intentInfo.value) return { intent: true }; // intent (setup itent)
  return {};
});

watch(
  () => props.invoice,
  (value) => {
    console.log('PaymentSuccess: invoice=', props.invoice, ' setupIntent: ', props.setupIntent);
    console.log('invoiceInfo: ', invoiceInfo.value);
    console.log('intentInfo: ', intentInfo.value);
    console.log('subscriptionInfo: ', subscriptionInfo.value);
    console.log('bankTransferInfo: ', bankTransferInfo.value);
    console.log('mandateInfo: ', mandateInfo.value);
  },
  { immediate: true },
);

// wizard embeddable
const addStep = inject('addStep') as ((s: PaymentWizardStep) => void) | undefined;

const paymentWizardStep = {
  key: PaymentWizardStepKey.PaymentSuccess,
  label: i18nn.tc('title.finished'),
  complete: true,
  submitText: i18nn.t('button.close'),
  hideCancel: true,
} as PaymentWizardStep;

if (addStep) addStep(paymentWizardStep);


return { __sfc: true,props, intentInfo, isIntentError, bankTransferInfo, invoiceInfo, subscription, subscriptionInfo, mandateInfo, visibleInfos, addStep, paymentWizardStep, PaymentSuccessIntent, PaymentSuccessInvoice, PaymentSuccessSubscription, PaymentSuccessBankTransferInstructions, PaymentSuccessMandateInstructions }
}

})